module.exports = __webpack_public_path__ + "static/media/bj.f00a8e22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bj.svg
// module id = 66
// module chunks = 0